module.exports = __webpack_public_path__ + "static/img/bg4.6019e57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/auth/img/bg/bg4.jpg
// module id = 1051
// module chunks = 17